import placesAutoComplete from "google/places-auto-complete";
import pageData from "common/page-data";

// Set up Google autocomplete in the CTV product page search modal
if (document.querySelector(".js-ctv-profile-search-form-city-state")) {
  placesAutoComplete.initializeCityState(
    ".js-ctv-profile-search-form-city-state",
    null,
    pageData.get("currentCountry")
  );
}
